export default {
  tags: {
    default: 'Por defecto',
    visible_to: 'Visible para',
    not_visible_to: 'No visible para',
  },
  labels: {
    inclusive: 'Incluido',
    exclusive: 'Excluido',
    public: 'Público',
  },
  buttons: {
    edit: 'Editar',
    delete: 'Eliminar',
  },
};
